export function isInRefArray<T>(tstValue: any, ref: T[]): tstValue is T {
  return ref.indexOf(tstValue) > -1;
}
